import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import { MeterSizeForm } from '@/components/forms/meter-size-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-size/add',
)({
  component: AddMeterSizePage,
})

export function AddMeterSizePage() {
  const [showMeterSizeModal, setShowMeterSizeModal] =
    React.useState<boolean>(false)
  return (
    <main>
      <div className="flex w-full justify-end">
        <Button
          onClick={() => {
            if (!validateUserAddPermission()) return
            setShowMeterSizeModal(true)
          }}
        >
          <Icons.add className="size-4" />
          Add Meter Size
        </Button>
      </div>
      <Credenza open={showMeterSizeModal} onOpenChange={setShowMeterSizeModal}>
        <CredenzaContent className="w-full md:min-w-[600px]">
          <CredenzaHeader>
            <CredenzaTitle>
              <Header
                subroutes={[
                  {
                    route: '/meter-connection-settings/meter-size',
                    label: 'Meter Size',
                  },
                ]}
              >
                Add Meter Size
              </Header>
            </CredenzaTitle>
          </CredenzaHeader>
          <CredenzaBody>
            <MeterSizeForm
              onClose={() => setShowMeterSizeModal(false)}
              setShowMeterSizeModal={setShowMeterSizeModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
